import { fixedUi } from '@/i18n/fixedUi';
import React, { useEffect, useMemo, useState } from 'react';
import { createPortal } from 'react-dom';
import { showToast } from '@/utils/toast';
import { parseBatchTokens, BATCH_QUERY_LIMIT } from './batchQueryUtils';

/**
 * 批量查询弹窗：换行或逗号分隔，上限 500 条
 */
export default function BatchQueryModal({
  open,
  title = fixedUi("批量查询"),
  initialValue = '',
  placeholder = '每行一条，或用逗号分隔；最多 500 条',
  onConfirm,
  onClose,
}) {
  const [text, setText] = useState('');

  useEffect(() => {
    if (!open) return;
    const tokens = parseBatchTokens(initialValue);
    setText(tokens.length ? tokens.join('\n') : '');
  }, [open, initialValue]);

  const tokens = useMemo(() => parseBatchTokens(text), [text]);
  const count = tokens.length;
  const overLimit = count > BATCH_QUERY_LIMIT;

  if (!open) return null;

  const handleConfirm = () => {
    const next = tokens.slice(0, BATCH_QUERY_LIMIT);
    if (overLimit) {
      showToast(`已按上限保留前 ${BATCH_QUERY_LIMIT} 条`, 'info');
    }
    onConfirm?.(next);
    onClose?.();
  };

  return createPortal(
    <div className="spo-batch-modal" role="presentation">
      <div className="spo-batch-modal__backdrop" aria-hidden="true" />
      <div
        className="spo-batch-modal__panel"
        role="dialog"
        aria-modal="true"
        aria-labelledby="spo-batch-modal-title"
      >
        <div className="spo-batch-modal__head">
          <h2 id="spo-batch-modal-title">{title}</h2>
          <button type="button" className="spo-btn spo-btn--ghost spo-btn--sm" onClick={onClose}>
            {fixedUi("关闭")}
          </button>
        </div>
        <div className="spo-batch-modal__body">
          <div className="spo-batch-modal__meta">
            <p className="spo-batch-modal__hint">
              支持换行或逗号分隔，单次最多查询 {BATCH_QUERY_LIMIT} 条
            </p>
            <span className={`spo-batch-modal__count${overLimit ? ' spo-batch-modal__count--warn' : ''}`}>
              已输入 {count} / {BATCH_QUERY_LIMIT}
              {overLimit ? '（超出将截断）' : ''}
            </span>
          </div>
          <textarea
            className="spo-textarea spo-batch-modal__textarea"
            value={text}
            placeholder={placeholder}
            onChange={(e) => setText(e.target.value)}
            rows={14}
            autoFocus
          />
        </div>
        <div className="spo-batch-modal__foot">
          <button type="button" className="spo-btn spo-btn--secondary spo-btn--sm" onClick={onClose}>
            {fixedUi("取消")}
          </button>
          <button type="button" className="spo-btn spo-btn--primary spo-btn--sm" onClick={handleConfirm}>
            确认
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
}
